import { render, staticRenderFns } from "./CreateAttendanceKidDetailExcel.vue?vue&type=template&id=50505fb4&scoped=true"
import script from "./CreateAttendanceKidDetailExcel.vue?vue&type=script&lang=js"
export * from "./CreateAttendanceKidDetailExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50505fb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50505fb4')) {
      api.createRecord('50505fb4', component.options)
    } else {
      api.reload('50505fb4', component.options)
    }
    module.hot.accept("./CreateAttendanceKidDetailExcel.vue?vue&type=template&id=50505fb4&scoped=true", function () {
      api.rerender('50505fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/CreateAttendanceKidDetailExcel.vue"
export default component.exports